<div class="menu-bar">
  <div class="game-menu">
    <button
      type="button"
      aria-label="Open or close menu"
      class="toggle-menu-button"
      [disabled]="isLoading"
      (click)="onToggleMenu()">
      <img
        [src]="
          isSidenavOpen()
            ? 'assets/menu-icons/Arrow-left.svg'
            : 'assets/menu-icons/Menu.svg'
        "
        alt="Open menu" />
    </button>
    @if (!isMobile()) {
      @for (game of games$ | async; track game.type) {
        <button
          type="button"
          class="game-button"
          [class.is-active]="game.type === gameType"
          [disabled]="isLoading"
          (click)="onSetGameType(game.type)">
          <mat-icon class="game-icon" [svgIcon]="game.icon"> </mat-icon>
          <span [class.isActive]="game.type === gameType" class="text-body-1">
            {{ game.title | translate }}
          </span>
        </button>
      }
    }
  </div>

  @if (client$ | async; as client) {
    <button
      type="button"
      class="client-trigger-button transparent-btn"
      [disabled]="isLoading"
      [matMenuTriggerFor]="clientMenu">
      <span class="client-trigger-button-text text-body-1">
        @if (client.logoAsset?.url) {
          <img
            [src]="client.logoAsset!.url"
            alt="Client Logo"
            class="client-logo" />
        }
        {{ client.name }}
        <img src="assets/menu-icons/Chevron-down.svg" alt="Arrow down" />
      </span>
    </button>
  }
</div>

<mat-menu #clientMenu="matMenu">
  <mat-action-list>
    @for (client of clients; track client) {
      <button mat-menu-item (click)="onSetClient(client)">
        <div class="client-container">
          @if (client.logoAsset?.url) {
            <img [src]="client.logoAsset?.url" alt="Client logo" />
          } @else {
            <mat-icon>people</mat-icon>
          }
          <span>{{ client.name }}</span>
        </div>
      </button>
    }
    @if (userRole === roles.Admin) {
      <button mat-menu-item (click)="onAddClient()">
        <mat-icon>add_circle</mat-icon>
        <span> {{ 'header.newClient' | translate }}</span>
      </button>
    }
  </mat-action-list>
</mat-menu>
